import React from "react";
import { Link } from "react-router-dom";
import withRole from "../../../../../Providers/AuthProvider/WithRole";

const AddCarLink = () => {
    return <Link to="/add/car"> Insert Vehicle </Link>;
};

export default withRole(AddCarLink, ["admin"]);
